import { memo } from "react";

interface ValueCardProps {
  image: string;
  title: string;
  description: string;
  alt: string;
  className?: string;
}

export const ValueCard = memo(({
  image,
  title,
  description,
  alt,
  className = "",
}: ValueCardProps) => (
  <article className={`group rounded-xl bg-card/80 backdrop-blur-sm border border-border/50 hover:border-primary/30 hover:shadow-hover card-hover overflow-hidden h-full flex flex-col ${className}`}>
    <div className="relative h-56 overflow-hidden flex-shrink-0">
      <img
        src={image}
        alt={alt}
        loading="lazy"
        decoding="async"
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
        width="1200"
        height="675"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" aria-hidden="true" />
    </div>
    <div className="p-8 flex flex-col flex-grow">
      <h3 className="text-xl font-semibold text-foreground mb-3 font-newsreader">
        {title}
      </h3>
      <p className="text-base text-muted-foreground leading-relaxed">
        {description}
      </p>
    </div>
  </article>
));

ValueCard.displayName = "ValueCard";
